import type { FaireProductEntity } from "../../entity_types/product";

export const p_mf4p5u8tvc: FaireProductEntity = {
  token: "p_mf4p5u8tvc",
  type: "product",
  name: "Tigers Eye Mini Pyramid - Tigers Eye Crystal",
  brandToken: "b_en1yij2pf6",
  brandName: "Natures Artifacts Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/e6dbc67df88ae81ca91588cdbb88d5d7bc66d953df10575d9a520fab77cf4338.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/24e2f4b7322ce9c46f2868dcf79085bfabbf3f9e8f9f29e0be9fb3dbd7f3dabd.jpeg",
    "https://cdn.faire.com/fastly/34a56840d239b6637384a47576cb1ea75116542ecb3df2894c2fd6fe3cead29d.jpeg",
    "https://cdn.faire.com/fastly/2625e4ab5a0e5b3b6d95ea5eef01cb01a678c107d3bd719ac213bd78cd103b07.jpeg",
    "https://cdn.faire.com/fastly/71beacb1491c78c44e7745c2b00eec72357b8d2705336b58fb00da8e3a68a133.jpeg",
    "https://cdn.faire.com/fastly/be5a6dc3b18562c8e0d763bf855a785e3555dba016d6f2f06e88c89015ea6fea.jpeg",
    "https://cdn.faire.com/fastly/e064c6c1c08310bf63e8da20b69f9564a865cae8e920c9b8507a781152179b2a.jpeg",
  ],
  priceDollars: 4.85,
  description:
    "The beautiful Tiger’s Eye, hand carved in the shape of a mini pyramid, makes a great addition to any decor display and a dainty gift for avid crystal lovers. Perfect to be used in mini crystal grids. Pyramids are mystical shapes that are very powerful for manifesting one’s desires, drawing off negative energy, and clearing blockages. Our Tiger’s Eye mini pyramid is ideal for meditation and healing practices with its grounding abilities at physical, mental and spiritual levels. Tiger’s Eye is a powerful stone that aids harmony and balance, helps release fear and anxiety, encourages courage, self confidence and will power. Enhances creativity and is one of the stones that aid kundalini awakening.",
  tags: [],
  msrpDollars: 9.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:00.643Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
